import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '@marketplace-web/browser/browser-storage-util'

import { SESSION_REFRESH_RECENT_MS, SESSION_REFRESH_STATUS_LOCAL_STORAGE_KEY } from '../constants'

type SessionRefreshStatus = {
  lastRefreshedAt: number
  isPending: boolean
}

const getSessionRefreshStatus = (): SessionRefreshStatus => {
  try {
    return JSON.parse(getLocalStorageItem(SESSION_REFRESH_STATUS_LOCAL_STORAGE_KEY) || '')
  } catch {
    return { lastRefreshedAt: 0, isPending: false }
  }
}

const updateSessionRefreshStatus = (status: Partial<SessionRefreshStatus>) => {
  const sessionRefreshStatus = getSessionRefreshStatus()

  try {
    setLocalStorageItem(
      SESSION_REFRESH_STATUS_LOCAL_STORAGE_KEY,
      JSON.stringify({
        ...sessionRefreshStatus,
        ...status,
      }),
    )
  } catch {
    /* empty */
  }
}

export const getIsSessionRefreshPending = () => getSessionRefreshStatus().isPending

export const getIsSessionRefreshedRecently = () => {
  const { lastRefreshedAt } = getSessionRefreshStatus()

  return new Date().getTime() - lastRefreshedAt < SESSION_REFRESH_RECENT_MS
}

export const startSessionRefreshStatus = () => {
  updateSessionRefreshStatus({ isPending: true })
}

export const stopSessionRefreshStatus = () => {
  updateSessionRefreshStatus({ isPending: false, lastRefreshedAt: new Date().getTime() })
}
